/**
 * @generated SignedSource<<006c78f494b8c0f4ce28b14c41c001fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApplyCampaignMutationInput = {
  campaignId: string;
  clientMutationId?: string | null;
  customPrice?: number | null;
  influencerId: string;
  note?: string | null;
};
export type ApplyMutation$variables = {
  input: ApplyCampaignMutationInput;
};
export type ApplyMutation$data = {
  readonly applyCampaign: {
    readonly __typename: "ApplyCampaignError";
    readonly message: string;
  } | {
    readonly __typename: "Influencer";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ApplyMutation = {
  response: ApplyMutation$data;
  variables: ApplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "applyCampaign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "type": "Influencer",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "ApplyCampaignError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApplyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e00f4e515c23dee4189154bd9830939",
    "id": null,
    "metadata": {},
    "name": "ApplyMutation",
    "operationKind": "mutation",
    "text": "mutation ApplyMutation(\n  $input: ApplyCampaignMutationInput!\n) {\n  applyCampaign(input: $input) {\n    __typename\n    ... on Influencer {\n      id\n    }\n    ... on ApplyCampaignError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b39f823ff7f90923a2a4cf5b30d3c6d9";

export default node;
